<div class="modal-header">
    <h4>Edit Trip</h4>
</div>
<div class="modal-body">
    <div>
        <label>Trip:</label><br />
        <input type="text" [(ngModel)]="formData.TripName" class="form-control" style="max-width:300px;" disabled />
    </div>
    <div>
        <label>Date:</label><br />
        <div class="input-group" style="max-width:300px;">
            <div class="input-group">
                <input type="text" class="form-control" bsDatepicker #ScheduledDate="bsDatepicker" [(ngModel)]="formData.ScheduledDate" [outsideClick]="true" name="ScheduledDate"
                       [bsConfig]="datepickerOptions" style="background-color:#ffffff">
                <div class="input-group-append">
                    <button type="button" class="btn btn-outline-secondary" (click)="ScheduledDate.show()" [attr.aria-expanded]="ScheduledDate.isOpen" style="margin-right:0px">
                        <i class="modus-icons align-bottom">calendar</i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div style="margin-bottom: 10px; max-width: 300px">
        <label>Time:</label><br />
        <timepicker [(ngModel)]="formData.ScheduledTime" [showMeridian]="true" [showSpinners]="false" ></timepicker>
    </div>

    <div style="margin-bottom:10px;">
        <label>Trip Description:</label>
        <textarea [(ngModel)]="formData.TripDescription" class="form-control" placeholder="Response" appElastic rows="2"
                  style="font-size:14px;overflow-y: hidden;max-width:300px;"></textarea>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text-primary" (click)="cancelClicked()">Close</button>
    <button type="button" class="btn btn-primary" (click)="saveClicked()">Save</button>
</div>